import type { NatureScatterDef } from '@/world-prototype/objects/natureScatter';

/**
 * Hubert backyard nature scatter (pinecones, future acorns, shells, …).
 *
 * Layouts: `layouts.desktop` / `layouts.tablet` / `layouts.mobile`. Flat fields mirror desktop.
 * Updated by World Editor (?edit=1).
 */
const SCATTER = `${import.meta.env.BASE_URL}art/environments/shared/scatter`;
const SHARED_PROP = `${import.meta.env.BASE_URL}art/environments/shared/props`;

export const BACKYARD_NATURE_SCATTER_DEFS: readonly NatureScatterDef[] = [
  {
    id: "bird-nest",
    title: "Bird Nest",
    icon: "🥚",
    actionLabel: "Look",
    enabled: true,
    x: 0.92457,
    y: 0.67612,
    widthFrac: 0.05,
    layouts: {
      desktop: {
        x: 0.92457,
        y: 0.67612,
        widthFrac: 0.05,
      },
      tablet: {
        x: 0.93004,
        y: 0.67361,
        widthFrac: 0.0378,
      },
      mobile: {
        x: 0.93096,
        y: 0.67016,
        widthFrac: 0.0381,
      },
    },
    interactive: false,
    sprite: {
      src: `${SCATTER}/bird-nest-v1.png`,
      alt: "Bird nest with eggs",
      imageWidth: 408,
      imageHeight: 325,
    },
    stand: { x: 0, y: 0.025 },
    hit: { x: 0, y: 0 },
    hitRadius: 0,
  },
  {
    id: "pinecone-1",
    title: "Pinecone 1",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: false,
    x: 0.52132,
    y: 0.36534,
    widthFrac: 0.0131,
    rotationDeg: 12,
    layouts: {
      desktop: {
        x: 0.52132,
        y: 0.36534,
        widthFrac: 0.0131,
        rotationDeg: 12,
      },
      tablet: {
        x: 0.3999,
        y: 0.43566,
        widthFrac: 0.0139,
        rotationDeg: 12,
      },
      mobile: {
        x: 0.53232,
        y: 0.36134,
        widthFrac: 0.014,
        rotationDeg: 12,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 377,
      y: 37,
      width: 99,
      height: 107,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-2",
    title: "Pinecone 2",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: false,
    x: 0.61488,
    y: 0.45074,
    widthFrac: 0.0131,
    rotationDeg: -18,
    layouts: {
      desktop: {
        x: 0.61488,
        y: 0.45074,
        widthFrac: 0.0131,
        rotationDeg: -18,
      },
      tablet: {
        x: 0.63109,
        y: 0.51768,
        widthFrac: 0.0139,
        rotationDeg: -18,
      },
      mobile: {
        x: 0.55583,
        y: 0.42132,
        widthFrac: 0.0089,
        scale: 1,
        rotationDeg: -18,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 707,
      y: 245,
      width: 105,
      height: 96,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-3",
    title: "Pinecone 3",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: true,
    x: 0.47855,
    y: 0.30748,
    widthFrac: 0.0076,
    rotationDeg: 28,
    layouts: {
      desktop: {
        x: 0.47855,
        y: 0.30748,
        widthFrac: 0.0076,
        scale: 1,
        rotationDeg: 28,
      },
      tablet: {
        x: 0.46012,
        y: 0.35332,
        widthFrac: 0.0078,
        scale: 1,
        rotationDeg: 28,
      },
      mobile: {
        x: 0.40719,
        y: 0.44198,
        widthFrac: 0.0082,
        scale: 1,
        rotationDeg: 28,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 37,
      y: 298,
      width: 104,
      height: 104,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-4",
    title: "Pinecone 4",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: true,
    x: 0.42972,
    y: 0.4563,
    widthFrac: 0.0078,
    rotationDeg: -8,
    layouts: {
      desktop: {
        x: 0.42972,
        y: 0.4563,
        widthFrac: 0.0078,
        scale: 1,
        rotationDeg: -8,
      },
      tablet: {
        x: 0.55242,
        y: 0.45011,
        widthFrac: 0.0078,
        scale: 1,
        rotationDeg: -8,
      },
      mobile: {
        x: 0.58379,
        y: 0.47368,
        widthFrac: 0.0079,
        scale: 1,
        rotationDeg: -8,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 1077,
      y: 402,
      width: 76,
      height: 80,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-5",
    title: "Pinecone 5",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: false,
    x: 0.41363,
    y: 0.41697,
    widthFrac: 0.0131,
    rotationDeg: 22,
    layouts: {
      desktop: {
        x: 0.41363,
        y: 0.41697,
        widthFrac: 0.0131,
        rotationDeg: 22,
      },
      tablet: {
        x: 0.33885,
        y: 0.57526,
        widthFrac: 0.05,
        rotationDeg: 22,
      },
      mobile: {
        x: 0.52434,
        y: 0.44816,
        widthFrac: 0.0082,
        scale: 1,
        rotationDeg: 22,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 497,
      y: 497,
      width: 95,
      height: 95,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-6",
    title: "Pinecone 6",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: true,
    x: 0.44152,
    y: 0.39417,
    widthFrac: 0.0074,
    rotationDeg: -25,
    layouts: {
      desktop: {
        x: 0.44152,
        y: 0.39417,
        widthFrac: 0.0074,
        scale: 1,
        rotationDeg: -25,
      },
      tablet: {
        x: 0.28884,
        y: 0.51577,
        widthFrac: 0.0079,
        scale: 1,
        rotationDeg: -25,
      },
      mobile: {
        x: 0.52031,
        y: 0.34605,
        widthFrac: 0.0072,
        scale: 1,
        rotationDeg: -25,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 377,
      y: 37,
      width: 99,
      height: 107,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-7",
    title: "Pinecone 7",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: false,
    x: 0.29571,
    y: 0.51558,
    widthFrac: 0.0131,
    rotationDeg: 15,
    layouts: {
      desktop: {
        x: 0.29571,
        y: 0.51558,
        widthFrac: 0.0131,
        rotationDeg: 15,
      },
      tablet: {
        x: 0.28668,
        y: 0.4675,
        widthFrac: 0.0139,
        rotationDeg: 15,
      },
      mobile: {
        x: 0.41811,
        y: 0.47818,
        widthFrac: 0.014,
        rotationDeg: 15,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 707,
      y: 245,
      width: 105,
      height: 96,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-8",
    title: "Pinecone 8",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: false,
    x: 0.58,
    y: 0.4,
    widthFrac: 0.0131,
    rotationDeg: -32,
    layouts: {
      desktop: {
        x: 0.58,
        y: 0.4,
        widthFrac: 0.0131,
        rotationDeg: -32,
      },
      tablet: {
        x: 0.572,
        y: 0.385,
        widthFrac: 0.0139,
        rotationDeg: -32,
      },
      mobile: {
        x: 0.591,
        y: 0.396,
        widthFrac: 0.014,
        rotationDeg: -32,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 37,
      y: 298,
      width: 104,
      height: 104,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-9",
    title: "Pinecone 9",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: true,
    x: 0.37523,
    y: 0.57384,
    widthFrac: 0.0083,
    rotationDeg: 6,
    layouts: {
      desktop: {
        x: 0.37523,
        y: 0.57384,
        widthFrac: 0.0083,
        scale: 1,
        rotationDeg: 6,
      },
      tablet: {
        x: 0.34126,
        y: 0.42799,
        widthFrac: 0.0077,
        scale: 1,
        rotationDeg: 6,
      },
      mobile: {
        x: 0.31022,
        y: 0.45615,
        widthFrac: 0.0078,
        scale: 1,
        rotationDeg: 6,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 1077,
      y: 402,
      width: 76,
      height: 80,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "pinecone-10",
    title: "Pinecone 10",
    icon: "🌲",
    actionLabel: "Kick",
    enabled: true,
    x: 0.64693,
    y: 0.39953,
    widthFrac: 0.008,
    rotationDeg: -14,
    layouts: {
      desktop: {
        x: 0.64693,
        y: 0.39953,
        widthFrac: 0.008,
        scale: 1,
        rotationDeg: -14,
      },
      tablet: {
        x: 0.592,
        y: 0.435,
        widthFrac: 0.0082,
        scale: 1,
        rotationDeg: -14,
      },
      mobile: {
        x: 0.611,
        y: 0.446,
        widthFrac: 0.0082,
        scale: 1,
        rotationDeg: -14,
      },
    },
    sprite: {
      src: `${SCATTER}/pinecones-v1.png`,
      alt: "Pinecone",
      imageWidth: 1190,
      imageHeight: 630,
    },
    spriteFrame: {
      x: 497,
      y: 497,
      width: 95,
      height: 95,
    },
    stand: { x: 0, y: 0.022 },
    hit: { x: 0, y: 0 },
    hitRadius: 0.014,
  },
  {
    id: "bucket",
    title: "Bucket",
    icon: "🪣",
    actionLabel: "Use",
    enabled: true,
    x: 0.742,
    y: 0.575,
    widthFrac: 0.0212,
    depth: 92,
    layouts: {
      desktop: {
        x: 0.742,
        y: 0.575,
        widthFrac: 0.0212,
        scale: 1,
        depth: 92,
      },
      tablet: {
        x: 0.73,
        y: 0.58,
        widthFrac: 0.0213,
        scale: 1,
        depth: 92,
      },
      mobile: {
        x: 0.735,
        y: 0.61,
        widthFrac: 0.0216,
        scale: 1,
        depth: 92,
      },
    },
    sprite: {
      src: `${SHARED_PROP}/bucket-v1.png`,
      alt: "Yard bucket",
      imageWidth: 690,
      imageHeight: 932,
    },
    stand: { x: 0, y: 0.035 },
    hit: { x: 0, y: -0.01 },
    hitRadius: 0.036,
  },
];
